export const getCurrentUser = () => {
  return window.firebaseApp.auth().currentUser
}

export const getCurrentUserId = () => {
  return window.firebaseApp.auth().getUid()
}

export const ensureUserInDb = user => {
  if (user) {
    const docRef = window.firebaseDb.collection('users').doc(user.uid)
    return docRef
      .get()
      .then(doc => {
        console.info("ENSURING USER")
        if (doc.exists) {
          // do nothing
          console.info("DOC: ", doc)
          if(!doc.data().createdAt){
            doc.ref.update({
              createdAt: new Date(),
              lastAccess: new Date()
            })
          }
          else{
            doc.ref.update({
              lastAccess: new Date()
            })
          }
        } else {
          doc.ref.set({
            displayName: user.displayName,
            name: user.displayName,
            email: user.email,
            uid: user.uid,
            photoURL: user.photoURL,
            createdAt: new Date()
          })
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/userHelpers.js